import { styled } from '@abyss/web/tools/styled';
import { PageFooter } from '@abyss/web/ui/PageFooter';
import { mobileOnly, phoneOnly } from '@/style/mediaQueries';

export const UmrFooterWrapper = styled(PageFooter, {
  '&.abyss-page-footer-root': {
    display: 'flex',
    justifyContent: 'center',
    padding: ' 0 $core.spacing.150 $core.spacing.300',
    [`@media print`]: {
      display: 'none',
    },
  },
  '&.abyss-page-footer-container': {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: 0,
    maxWidth: 'var(--abyss-sizes-core-size-lg, 1248px)',
    padding: 0,
    '& .abyss-page-footer-sub-wrapper': {
      marginBottom: '8px',
      '& .abyss-page-footer-copyright-container': {
        fontWeight: '600',
      },
      '& .abyss-page-footer-sub-link:before': {
        bottom: '3px',
        borderBottomWidth: '1px',
        left: 0,
        textDecoration: 'underline',
        transition: 'none',
        width: '100%',
      },
      '& .abyss-page-footer-sub-link:hover:before': {
        transition: 'none',
        width: '0%',
      },
    },
  },
  '&.abyss-page-footer-links': {
    margin: '0 0 32px 0',
    paddingBottom: '32px',
    '& .abyss-page-footer-link': {
      fontSize: '$sm',
    },
  },
  [`@media ${mobileOnly}`]: {
    '&.abyss-page-footer-links': {
      flexDirection: 'column',
    },
    '&.abyss-page-footer-container': {
      '& .abyss-page-footer-sub-wrapper': {
        flexDirection: 'column',
        gap: '8px',
      },
    },
    [`@media ${phoneOnly}`]: {
      '&.abyss-page-footer-container': {
        '& .abyss-page-footer-sub-wrapper': {
          '& .abyss-page-footer-sub-nav': {
            '& .abyss-page-footer-sub-list-container': {
              display: 'flex',
              flexWrap: 'wrap',
            },
          },
        },
      },
    },
  },
});

export const UmrFooterSection = styled(PageFooter.Section, {
  margin: 0,
  paddingTop: '32px',
  '& .abyss-page-footer-section-title': {
    // !important is required because Abyss uses it in their styles making it
    // impossible to override without it
    fontSize: '16px !important',
    marginBottom: '12px !important',
    padding: 0,
  },
  '& .abyss-page-footer-list-container': {
    padding: 0,
  },
  '& .abyss-page-footer-link-item': {
    // !important is required because Abyss uses it in their styles making it
    // impossible to override without it
    marginTop: '0 !important',
  },
});

export const UmrFooterLink = styled(PageFooter.Link, {
  '&.abyss-page-footer-link': {
    fontWeight: '600',
    textUnderlineOffset: '1px',
  },
  '&.abyss-page-footer-link:hover:before': {
    width: '0%',
  },
});

export const UmrFooterLinkText = styled('span', {
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const GehaFooterWrapper = styled('footer', {
  backgroundColor: '$core.color.neutral.5',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  padding: '24px 0',
  rowGap: '10px',
});

export const GehaFooterLink = styled('a', {
  borderRight: '1px solid $core.color.neutral.20',
  color: '$core.color.neutral.80',
  fontSize: '11px',
  fontWeight: '600',
  padding: '0 16px',
  '&:hover': {
    color: 'inherit',
    textDecoration: 'underline',
  },
  '&:last-child': {
    borderRight: 'none',
  },
});
